import _typeof from "@babel/runtime/helpers/esm/typeof";
import { propOr } from 'ramda';
import { getType, isArray, isObject, isString } from './type'; // eslint-disable-next-line @typescript-eslint/no-empty-function

var noop = function noop() {};

var storagePlaceholder = {
  get: noop,
  getItem: noop,
  remove: noop,
  removeItem: noop,
  set: noop,
  setItem: noop
};

var getStorageApiByName = function getStorageApiByName(storageName) {
  var isClient = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object';
  var storage;

  if (isClient) {
    if (storageName === 'localStorage') {
      storage = localStorage;
    } else if (storageName === 'sessionStorage') {
      storage = sessionStorage;
    }
  } else {
    storage = storagePlaceholder;
  }

  var setValue = function setValue(key, value) {
    try {
      storage.setItem(key, isObject(value) || isArray(value) ? JSON.stringify(value) : value);
    } catch (error) {
      if (error.name === 'QuotaExceededError') {// не обрабатываем
      } else {
        throw error;
      }
    }
  };

  var getValue = function getValue(key) {
    var value = storage.getItem(key);

    if (isString(value) && (value[0] === '[' || value[0] === '{')) {
      return JSON.parse(value);
    }

    return value;
  };

  var removeValue = function removeValue(key) {
    storage.removeItem(key);
  };

  var setValues = function setValues(values, options) {
    if (!isObject(values)) {
      // eslint-disable-next-line no-console
      console.error("argument must be \"Object\" type, but got \"".concat(getType(values), "\""));
      return;
    }

    var keys = Object.keys(values);
    keys.forEach(function (key) {
      setValue(key, isObject(values[key]) ? values[key].value : values[key], propOr(options, 'options', values[key]));
    });
  };

  var getValues = function getValues(keys, options) {
    if (!isArray(keys)) {
      // eslint-disable-next-line no-console
      console.error("argument must be \"Array\" type, but got \"".concat(getType(keys), "\""));
      return;
    } // eslint-disable-next-line consistent-return


    return keys.reduce(function (acc, key) {
      acc[key] = getValue(isObject(keys[key]) ? keys[key].value : key, propOr(options, 'options', keys[key]));
      return acc;
    }, {});
  };

  var removeValues = function removeValues(keys, options) {
    if (!isArray(keys)) {
      // eslint-disable-next-line no-console
      console.error("argument must be \"Array\" type, but got \"".concat(getType(keys), "\""));
      return;
    }

    keys.forEach(function (key) {
      removeValue(isObject(keys[key]) ? keys[key].value : key, propOr(options, 'options', keys[key]));
    });
  };

  return {
    getValue: getValue,
    getValues: getValues,
    removeValue: removeValue,
    removeValues: removeValues,
    setValue: setValue,
    setValues: setValues
  };
};

var _getStorageApiByName = getStorageApiByName('localStorage'),
    getLocalValue = _getStorageApiByName.getValue,
    getLocalValues = _getStorageApiByName.getValues,
    setLocalValue = _getStorageApiByName.setValue,
    setLocalValues = _getStorageApiByName.setValues,
    removeLocalValue = _getStorageApiByName.removeValue,
    removeLocalValues = _getStorageApiByName.removeValues;

var _getStorageApiByName2 = getStorageApiByName('sessionStorage'),
    getSessionValue = _getStorageApiByName2.getValue,
    getSessionValues = _getStorageApiByName2.getValues,
    setSessionValue = _getStorageApiByName2.setValue,
    setSessionValues = _getStorageApiByName2.setValues,
    removeSessionValue = _getStorageApiByName2.removeValue,
    removeSessionValues = _getStorageApiByName2.removeValues;

export { getLocalValue, getLocalValues, getSessionValue, getSessionValues, removeLocalValue, removeLocalValues, removeSessionValue, removeSessionValues, setLocalValue, setLocalValues, setSessionValue, setSessionValues };